import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ChartTypes } from '@mode/shared/contract-common';
import { FormatListItem } from '../format-list-item';

@Component({
  selector: 'mode-format-builder-pane',
  templateUrl: './pane.component.html',
  styleUrls: ['./pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaneComponent implements OnChanges {
  @Input() field!: FormatListItem;
  @Input() format!: ChartTypes.PaneFieldFormat;
  @Input() chartType!: ChartTypes.ChartType;
  @Output() update = new EventEmitter<ChartTypes.PaneFieldFormat>();

  updateDefaultFormat(format: ChartTypes.TextFormat) {
    this.update.emit({
      default: format,
    });
  }

  updateRotation(rotation: number) {
    const label = { ...this.format?.label, rotation };
    this.format = { ...this.format, label };
    this.update.emit({
      ...this.format,
    });
  }

  ngOnChanges(props: SimpleChanges) {
    if (props.format) {
      this.format = props.format.currentValue ?? {};
    }
  }
}
